import {
  Box,
  Grid,
  Typography,
  Select,
  DialogTitle,
  Dialog,
  IconButton,
  DialogContent,
} from "@mui/material";
import styles from "./devoteeManagement.module.scss";
import { useState, useEffect } from "react";
import { object, string, ValidationError } from "yup";
import { isEmpty, isNil } from "lodash";
import {
  CustomInputLabel,
  CustomTextFeild,
  CommonButton,
  CustomMenuItem,
  CustomSelect,
  ContactNumberInput,
  formatAmount,
  CommonOutlinedButton,
} from "../common/StyledComponents/StyledFields";
import rightArrow from "../../assets/svg/right_Arrow.svg";
import leftArrow from "../../assets/svg/left_Arrow.svg";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import ToastError from "../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../config/apiPaths.json";
import ToastSuccess from '../common/toast/toastSuccess';
import CloseIcon from "@mui/icons-material/Close";
import { BeatLoader, BounceLoader, ClipLoader } from 'react-spinners';
import LOCALE from "../../config/en-us.json";
import SuccessPopup from '../devotee/donation/successPopup';
import ErrorPopup from '../common/ErrorPopup';
import constants from "../../config/constants.json"

interface ErrorMessageTypes {
  firstName: string;
  lastName: string;
  userName: string;
  phoneNumber: string;
}

const formFields = {
  firstName: "",
  lastName: "",
  userName: "",
  phoneNumber: "",
};

const ConsolidatedAccounts = (): JSX.Element => {
  const [formData, setFormData] = useState({ ...formFields });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...formFields,
  });

  const devoteesList = [
    {
      devotee: "vinay",
    },
    {
      devotee: "vinay12",
    },
    {
      devotee: "susmitha",
    },
    {
      devotee: "hari",
    },
    {
      devotee: "deepika2",
    },
  ];

  const SignInNamesList = [
    {
      signInName: "hari1",
    },
    {
      signInName: "hari2",
    },
    {
      signInName: "hari3",
    },
    {
      signInName: "hari4",
    },
    {
      signInName: "hari5",
    },
  ];

  const devoteeTableList = [
    {
      devoteeDetails: "vinay1",
      transactionDetails: "abcd1",
      moveTo: "hari1",
    },
    {
      devoteeDetails: "vinay2",
      transactionDetails: "abcd2",
      moveTo: "hari2",
    },
    {
      devoteeDetails: "vinay3",
      transactionDetails: "abcd3",
      moveTo: "hari3",
    },
    {
      devoteeDetails: "vinay4",
      transactionDetails: "abcd4",
      moveTo: "hari4",
    },
    {
      devoteeDetails: "vinay5",
      transactionDetails: "abcd5",
      moveTo: "hari5",
    },
  ];

  const [selectedDevoteeNames, setSelectedDevoteeNames] = useState<string[]>(
    []
  );
  const [selectedSignInNames, setSelectedSignInNames] = useState<string[]>([]);
  const [showDevoteeDetails, setShowDevoteeDetails] = useState<boolean>(false);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [showdevoteeTable, setShowdevoteeTable] = useState<boolean>(false);
  const [submitButton, setSubmitButton] = useState<boolean>(false);
  const [selectedDevoteeNamesList, setSelectedDevoteeNamesList] = useState<
    any[]
  >([]);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [accountsToConsolidateDetails, setAccountsToConsolidateDetails] =
    useState<any[]>([]);
  const [donationSummeryList, setDonationSummeryList] = useState<any[]>([]);
  const [donationSummeryAmount, setDonationSummeryAmount] = useState("");
  const [moveButtonDisable, setMoveButtonDisable] = useState<boolean>(true);

  console.log(donationSummeryList, "donationSummeryListdonationSummeryList");

  const [fromUsername, setFromUsername] = useState("");
  const [toUsername, setToUsername] = useState("");
  const [moveList, setMoveList] = useState<any[]>([]);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [usernames, setUsernames] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [moveLoading, setMoveLoading] = useState(false);

  const validationSchema = object().shape({
    // firstName: string().required('First Name is required'),
    // lastName: string().required('Last Name is required'),
    // userName: string().required('User Name is required'),
    // phoneNumber: string()
    //    .required("Contact Number is required")
    //    .matches(/^\+1 \(\d{3}\) \d{3}-\d{4}$/, "Phone Number Should be 10 Characters"),
  });

  const handleSave = async (): Promise<any> => {
    const errors: ErrorMessageTypes = { ...formFields };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // handleSearch();

      // Call your API or perform other actions here
      consolidateAccountSearchApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const consolidateAccountSearchApi = () => {
    setSearchLoading(true);
    const reqBody = {
      firstname: formData.firstName,
      lastname: formData.lastName,
      username: formData.userName,
      phoneNumber: formData.phoneNumber,
      matchOperator: "AND",
    };

    apiRequest({
      method: "POST",
      endpoint: apiPath.serachDevoteeApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setUsersList(res.data.content);
        setShowDevoteeDetails(true);
        setSearchButton(true);
        setSelectedDevoteeNamesList([]);
        setSelectedDevoteeNames([]);
        setSearchLoading(false);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setSearchLoading(false);
      });
  };

  const handleSubmit = () => {
    consolidateAccountSubmitApi();
  };

  const consolidateAccountSubmitApi = () => {
    setSubmitLoading(true);
    const reqBody = {
      accountsToConsolidate: selectedDevoteeNamesList,
    };

    apiRequest({
      method: "POST",
      endpoint: apiPath.accountsToConsolidate,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        console.log(res);
        setShowdevoteeTable(true);
        setSubmitButton(true);
        setUsernames(res.data);
        getAccountsToConsolidate();
        setSubmitLoading(false);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setSubmitButton(false);
        setSubmitLoading(false);
      });
  };

  useEffect(() => {
    getAccountsToConsolidate();
  }, []);

  const getAccountsToConsolidate = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.accountsToConsolidate,
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data, "dataaaa");
        setUsernames(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const getDonationSummaryApi = (item: string) => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.donationSummaryApi}/${item}/donationSummary`,
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data, "eventssssssssssssssss");
        setDonationSummeryList(res.data.donationsByDay);
        setDonationSummeryAmount(res.data.totalDonation);
        // setOpenCancelDialog(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setLoading(false);
      });
  };

  const consolidateAccountMoveApi = () => {
    setMoveLoading(true);
    const reqBody = {
      accountsToConsolidate: moveList,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.consolidateAccountMoveApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data);
        const successMessage = LOCALE.CONSOLIDATE_MOVED_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //    duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="Accounts"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setMoveLoading(false);
        getAccountsToConsolidate();
        setMoveButtonDisable(true);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setMoveLoading(false);
      });
  };

  const consolidateClearApi = () => {
    // const reqBody = {
    //    accountsToConsolidate: moveList
    // }
    apiRequest({
      method: "DELETE",
      endpoint: apiPath.accountsToConsolidate,
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data);
        const successMessage = LOCALE.CONSOLIDATES_CLEARED_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //    duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="Accounts"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        getAccountsToConsolidate();
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleFieldChange = (field: any, value: any) => {
    setShowDevoteeDetails(false);
    if (
      formData.firstName ||
      formData.userName ||
      formData.lastName ||
      formData.phoneNumber
    ) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleDropdownChange = (fromUsername: string, toUsername: string) => {
    setFromUsername(fromUsername);
    setToUsername(toUsername);
    setMoveList([
      ...moveList,
      { fromUsername: fromUsername, toUsername: toUsername },
    ]);
    setMoveButtonDisable(false);
  };

  const handleDevoteeSelect = (devoteeName: string) => {
    if (selectedDevoteeNames.includes(devoteeName)) {
      // If the devoteeName is already selected, remove it
      setSelectedDevoteeNames((prevSelected) =>
        prevSelected.filter((name) => name !== devoteeName)
      );
    } else {
      // If the devoteeName is not selected, add it to the list
      setSelectedDevoteeNames((prevSelected) => [...prevSelected, devoteeName]);
    }
  };

  const handleSignInNameSelect = (devoteeName: string) => {
    if (selectedSignInNames.includes(devoteeName)) {
      setSelectedSignInNames((prevSelected) =>
        prevSelected.filter((name) => name !== devoteeName)
      );
    } else {
      setSelectedSignInNames((prevSelected) => [...prevSelected, devoteeName]);
    }
  };

  const handleRightClick = () => {
    setSelectedDevoteeNamesList(selectedDevoteeNames);
    setSubmitButton(false);
    setShowdevoteeTable(false);
  };

  const handleLeftClick = () => {
    const updatedList = [...selectedDevoteeNamesList];
    // Find the index of the last selected item
    const lastIndex = updatedList.length - 1;
    // Remove the last selected item from the list
    updatedList.splice(lastIndex, 1);
    // Update the state with the updated list
    setSelectedDevoteeNamesList(updatedList);
    setSubmitButton(false);
    setShowdevoteeTable(false);
  };

  const handleOpenDialog = (item: string) => {
    getDonationSummaryApi(item);
    setOpenCancelDialog(true);
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
  };

  const handlePrint = () => {
    window.print();
  };

  const devoteAndSignInName = () => {
    if (usersList.length === 0) {
      return <Typography sx={{margin:"24px auto",color:"red",fontSize:"28px"}}><b>No Records found</b></Typography>;
    }

    const handleSubmitPress = (e:any) => {
      if (e.key === 'Enter') {
        e.preventDefault(); // Prevent the default form submission behavior
        handleSubmit();
      }
    };

    return (
      < >
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            flexDirection: "row",
            margin: "20px 10px",
            gap: "30px",
          }}
        >
          <Grid>
            <Typography>Devotee</Typography>
            <Grid className={styles.devoteeContainer}>
              {usersList.map((item, index) => (
                <Typography
                  key={index}
                  className={
                    selectedDevoteeNames.includes(item.username)
                      ? styles.selectedDevoteeStyles
                      : styles.unselectedDevoteeStyles
                  }
                  onClick={() => handleDevoteeSelect(item.username)}
                >
                  {`${item.firstname} ${item.lastname} (${item.username})`}
                </Typography>
              ))}
            </Grid>
          </Grid>
          <Grid className={styles.arrowImages}>
            <img src={rightArrow} onClick={handleRightClick} alt="rightArrow" />
            <img src={leftArrow} onClick={handleLeftClick} alt="leftArrow" />
          </Grid>
          <Grid>
            <Typography>Sign-In-Name</Typography>
            <Grid className={styles.devoteeContainer}>
              {selectedDevoteeNamesList.map((item, index) => (
                <Typography
                  key={index}
                  className={
                    selectedSignInNames.includes(item)
                      ? styles.selectedDevoteeStyles
                      : styles.unselectedDevoteeStyles
                  }
                  onClick={() => handleSignInNameSelect(item)}
                >
                  {item}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Box sx={{ margin: "20px 10px" }}>
          <CommonButton
            onClick={handleSubmit}
            disabled={submitButton || selectedDevoteeNamesList.length < 2}
            onKeyDown={handleSubmitPress}
          >
            {submitLoading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Please wait...
                </span>
              </>
            ) : (
              "Submit"
            )}
          </CommonButton>
        </Box>
      </>
    );
  };

  const moveToDropdown = (
    fromUsername: string,
    selectedDevoteeNamesList: any[]
  ): React.ReactElement => {
    return (
      <FormControl className={styles.moveToDropdown}>
        <Select
          sx={{ background: "#fff", padding: "2px", height: "30px" }}
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          // value={formData.moveTo}
          onChange={(e) => handleDropdownChange(fromUsername, e.target.value)}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "200px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#fff",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {selectedDevoteeNamesList
            .filter((item) => item !== fromUsername) // Filter out the fromUsername
            .map((item, index) => (
              <CustomMenuItem key={index} value={item}>
                {item}
              </CustomMenuItem>
            ))}
        </Select>
      </FormControl>
    );
  };

  const handleMovePress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      consolidateAccountMoveApi();
    }
  };

  const devoteAndSignInNameTable = (): JSX.Element => {
    return (
      <div className={styles.table}>
        {usernames.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Devotee Details</th>
                <th className={styles.tableHorizontal}>Transaction Details</th>
                <th className={styles.tableHorizontal}>
                  Move All Transcations To
                </th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {usernames.map((item, i: number) => {
                const filteredList = usernames.filter(
                  (item, index) => index !== i
                );
                return (
                  <tr key={i} className={styles.tableRow}>
                    <td className={styles.tableDiagonal}>{item}</td>
                    <td className={styles.tableDiagonal}>
                      <a href="#" onClick={() => handleOpenDialog(item)}>
                        Details
                      </a>
                    </td>
                    <td className={styles.tableDiagonal}>
                      {moveToDropdown(item, filteredList)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p>No Data</p>
        )}
        <Box sx={{ marginTop: "24px", display: "flex", gap: "10px" }}>
          <CommonButton
            onClick={consolidateAccountMoveApi}
            disabled={moveButtonDisable}
            onKeyDown={handleMovePress}
          >
            {moveLoading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Please wait...
                </span>
              </>
            ) : (
              "Move"
            )}
          </CommonButton>
          <CommonOutlinedButton onClick={consolidateClearApi}>
            Clear
          </CommonOutlinedButton>
        </Box>
      </div>
    );
  };

  const summaryTableComponent = (date: string, donationList: any[]) => {
    return (
      <>
        <Typography>{date}</Typography>
        {donationList.length > 0 ? (
          donationSummaryTable(donationList)
        ) : (
          <Typography sx={{ textAlign: "center" }}>No Data</Typography>
        )}
      </>
    );
  };

  const summaryTableDateComponent = () => {
    return (
      <>
        {donationSummeryList.map((item, i) => (
          <div key={i}>
            {summaryTableComponent(item.donationDate, item.donations)}
          </div>
        ))}
        <Box sx={{ margin: "24px 0px" }}>
          <Typography>
            Total Amount: {formatAmount(donationSummeryAmount)}
          </Typography>
        </Box>
        <Box
          sx={{
            margin: "24px 0px",
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            justifyContent: "end",
          }}
        >
          {donationSummeryList.length != 0 ? (
            <>
              <CommonButton sx={{ float: "right" }} onClick={handlePrint}>
                Print
              </CommonButton>
            </>
          ) : (
            ""
          )}
        </Box>
      </>
    );
  };

  const donationSummaryTable = (donationList: any[]): JSX.Element => {
    return (
      <div className={styles.table}>
        {donationList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Receipt No</th>
                <th className={styles.tableHorizontal}>Name (Sign-In)</th>
                <th className={styles.tableHorizontal}>Mode of Payment</th>
                <th className={styles.tableHorizontal}>Check Number</th>
                <th className={styles.tableHorizontal}>Donation/Puja(ID)</th>
                <th className={styles.tableHorizontal}>DonationID</th>
                <th className={styles.tableHorizontal}>Date</th>
                <th className={styles.tableHorizontal}>Amount</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {donationList.map((item, i: number) => {
                return (
                  <tr key={i} className={styles.tableRow}>
                    <td className={styles.tableDiagonal}>
                      {item?.receiptNumber}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.fullname}
                      <br />({item?.username})
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.modeOfPayment}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.checkNumber}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.donationPurpose}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.donationsPurposeId}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item?.dateOfDonation}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {formatAmount(item?.amount)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
      </div>
    );
  };

  return (
    <form className={styles.ConsolidateAccountLayout} onSubmit={handleSave}>
      <Toaster />
      <Typography className={styles.SubHeading}>
        Consolidate Accounts
      </Typography>
      <Grid className={styles.mainLayout}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item id="firstName">
            <CustomInputLabel>First Name</CustomInputLabel>
            <CustomTextFeild
              fullWidth
              required
              value={formData.firstName}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, firstName: "" });
                handleFieldChange("firstName", e.target.value);
              }}
              className={
                !isEmpty(errorMessage.firstName)
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Firstname"
            />
            {!isEmpty(errorMessage.firstName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.firstName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item id="lastName">
            <CustomInputLabel>Last Name</CustomInputLabel>
            <CustomTextFeild
              fullWidth
              required
              value={formData.lastName}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, lastName: "" });
                handleFieldChange("lastName", e.target.value);
              }}
              className={
                !isEmpty(errorMessage.lastName)
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Lastname"
            />
            {!isEmpty(errorMessage.lastName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.lastName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item id="userName">
            <CustomInputLabel>User Name</CustomInputLabel>
            <CustomTextFeild
              fullWidth
              required
              value={formData.userName}
              onChange={(e) => {
                const inputUserName = e.target.value;
                if (inputUserName.length <= 10 && !/\s/.test(inputUserName)) {
                  setErrorMessage({ ...errorMessage, userName: "" });
                  handleFieldChange("userName", inputUserName);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    userName: "Username must be 4 to 10 characters.",
                  });
                }
              }}
              onBlur={() => {
                const inputUserName = formData.userName.toUpperCase();
                handleFieldChange("userName", inputUserName);
                // Check the length when the input field loses focus
                if (formData.userName.length < 4) {
                  setErrorMessage({
                    ...errorMessage,
                    userName: "Username must be at least 4 characters.",
                  });
                }
              }}
              className={
                !isEmpty(errorMessage.userName)
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Username"
            />
            {!isEmpty(errorMessage.userName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.userName}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} sx={{ marginTop: "24px" }} id="phoneNumber">
            <CustomInputLabel>Phone Number</CustomInputLabel>
            <CustomTextFeild
            fullWidth
              required
              value={formData.phoneNumber}
              onChange={(e) => {
                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
              const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                setErrorMessage({ ...errorMessage, phoneNumber: "" });
                handleFieldChange("phoneNumber", slicedNumber);
              }}
              className={
                errorMessage.phoneNumber
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Phone Number"
            />
            {errorMessage.phoneNumber ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.phoneNumber}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Box sx={{ marginTop: "24px" }}>
          <CommonButton
            onClick={handleSave}
            disabled={searchButton || searchLoading}
            type="submit"
          >
            {searchLoading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Please wait...
                </span>
              </>
            ) : (
              "Search"
            )}
          </CommonButton>
        </Box>
      </Grid>
      {showDevoteeDetails ? <Grid>{devoteAndSignInName()}</Grid> : ""}
      {showdevoteeTable || usernames.length > 0 ? (
        <Grid>{usernames.length > 0 ? devoteAndSignInNameTable() : ""}</Grid>
      ) : (
        ""
      )}

      <Dialog
        open={openCancelDialog}
        onClose={handleCancelDialogClose}
        aria-labelledby="cancel-dialog-title"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "804px",
            maxHeight: "auto",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        {/* {loading ? <ClipLoader /> : null} */}
        <div
          style={{
            backgroundColor: "#882E14",
            width: "auto",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
          >
            {"All Transactions"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCancelDialogClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BounceLoader color="#22A699" loading={loading} size={45} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Please wait...
              </span>
            </div>
          ) : (
            <div>
              {donationSummeryList.length > 0 ? (
                summaryTableDateComponent()
              ) : (
                <Typography sx={{ textAlign: "center" }}>No Data</Typography>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </form>
  );
};

export default ConsolidatedAccounts;
